import { StorageService } from './../../services/storage.service';
import { PERMISSIONS, PermissionsService } from './../../services/permissions/permissions.service';
import {Component, OnInit, OnDestroy} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {CreateImportComponent} from './components/create-import/create-import.component';
import {ImportService, ImportsFilter} from './servers/import.service';
import {AppUserOutput} from '../../users-api';
import {Subscription, timer} from 'rxjs';


const TYPES_PER_PERMISSION = {
[PERMISSIONS.IMPORTER_USERS_BY_APPID] :'users_by_appid',
[PERMISSIONS.IMPORTER_BANK_TRANSACTIONS] :['bank_transactions','transaction_credits'],
[PERMISSIONS.IMPORTER_BANK_TRANSACTIONS_VIEW] :['bank_transactions','transaction_credits'],
[PERMISSIONS.IMPORTER_KPI] :'kpis',
//[PERMISSIONS.IMPORTER_CENTRAL_DELIVERIES_UPDATER] :'central_deliveries_updater',
//[PERMISSIONS.IMPORTER_CENTRAL_PREINVOICES_UPDATER] :'central_preinvoices_updater',
[PERMISSIONS.IMPORTER_ORDERS_BY_ADMIN] :'bonos_orders_admin',
[PERMISSIONS.IMPORTER_RECOGNITIONS_POINTS] :'recognitions_points',
//[PERMISSIONS.IMPORTER_CENTRAL_ORDER_OFFLINE] :'central_order_offline',


}
@Component({
  selector: 'app-imports',
  templateUrl: './imports.component.html',
  styleUrls: ['./imports.component.scss']
})
export class ImportsComponent implements OnInit, OnDestroy {
  PERMISSIONS = PERMISSIONS;
  displayedColumns = ['info'];
  dataImports: any[];
  loading: boolean;
  hoveredRow: any;
  pageSize = 20;
  filters: ImportsFilter;
  refreshSubscription: Subscription;
  appIdFilter: string | undefined;
  statusFilter = '';
  typeFilter = '';
  userFilter: AppUserOutput | undefined;
  filterByDate = false;
  allowedAppIds: string[] | null;
  allowAllAppIds = false;
  fechaInicio: string;
  fechaFin: string;


  constructor(
    public dialog: MatDialog,
    private importador: ImportService,
    private storageService: StorageService,
    private permissions: PermissionsService
  ) {}

  async ngOnInit() {
    await this.importador.configFirebase();
    this.initAllowedIds();
    this.loading = true;
   /*  this.refreshSubscription = timer(0, 60000).subscribe(async () => {
     // await this.refreshData();
    }); */
    this.loading = false;
  }
  initAllowedIds() {
    // Do not allow any app by default
    this.allowedAppIds = [];
    this.allowAllAppIds = false;
    const account = this.storageService.get('account');
    
    if (!account) {
      return;
    }
    if (account.roles.includes('super_admin')) {
      // Allow all ids
      this.allowedAppIds = null;
      this.allowAllAppIds = true;
      return;
    }
    const profile = this.storageService.get('profile');
    if (!profile) {
      return;
    }
    
    this.permissions.hasPermission(PERMISSIONS.ACCESS_ALL).then(data => {
      if(data){
        this.allowedAppIds = null;
        this.allowAllAppIds = true;
        return;
      }
    });
    
    this.allowedAppIds = profile.authorized_apps || [];

  }

  ngOnDestroy() {
    this.refreshSubscription?.unsubscribe();
  }

  openCreateImports() {
    const dialogRef = this.dialog.open(CreateImportComponent);
    dialogRef.afterClosed().subscribe(async () => {
      await this.refreshData();
    });
  }

  async pageSizeCtrlChanged() {
    this.loading = true;
    await this.refreshData();
    this.loading = false;
  }

  canFilterByAppId() {
    return [
      'bank_transactions',
      'kpis',
      'users_by_appid',
      'bonos_orders_admin',
    ].includes(this.typeFilter);
  }

  async refreshData() {
    if (!this.filters) {
      this.filters = {};
    }
    if (this.canFilterByAppId() && this.appIdFilter) {
      this.filters.appId = this.appIdFilter;
    } else {
      delete this.filters.appId;
    }
    if (this.statusFilter) {
      this.filters.status = this.statusFilter;
    } else {
      delete this.filters.status;
    }
    if (this.typeFilter) {
      this.filters.type = this.typeFilter;
    } else {
      delete this.filters.type;
    }
    if (this.userFilter) {
      this.filters.uid = this.userFilter.id;
    } else {
      delete this.filters.uid;
    }
    let pageSize = this.pageSize;
    if (!this.filterByDate) {
      delete this.filters.date;
    } else {
      pageSize *= 100;
    }
    this.loading = true;
    
    const types =  Object.keys(TYPES_PER_PERMISSION).map( (key) => {
      if ( this.permissions.hasPermissionNoPromise(key)){
        return TYPES_PER_PERMISSION[key];
      }
    }).filter(x => x).flat();

    this.allowAllAppIds = this.allowAllAppIds || this.permissions.hasPermissionNoPromise(PERMISSIONS.ACCESS_ALL)
    this.dataImports = await this.importador.readAllImports(pageSize, this.filters, this.allowedAppIds, this.allowAllAppIds,types);
    this.loading = false;
  }

  selectUser($event: AppUserOutput) {
    if (!this.filters) {
      this.filters = {};
    }
    this.filters.uid = $event.id;
    this.userFilter = $event;
  }

  addFilterDate(value1: any, value2: any) {
    if (!this.filters) {
      this.filters = {};
    }
  
    this.filters.date = {
      start: value1 ? value1.hour(0).minute(0).second(0).toDate() : null,
      end: value2 ? value2.hour(23).minute(59).second(59).toDate() : null
    };
  }

  appIdFilterSelected(value: string) {
    if (this.appIdFilter === value) {
      return;
    }
    this.appIdFilter = value;
    if (!this.filters) {
      this.filters = {};
    }
    this.filters.appId = value;
  }

  clearFilters() {
    this.filters = {};
    this.appIdFilter = undefined;
    this.statusFilter = '';
    this.typeFilter = '';
    this.userFilter = undefined;
    this.filterByDate = false;
    this.refreshData();
  }
}
